import React from "react";
import Moment from 'react-moment';

import { Flex, Box, Heading, Spacer, Center, Badge, Stat, StatLabel, StatNumber, Tooltip, IconButton, InputGroup, Input, InputLeftAddon, InputRightElement, useClipboard, useToast, StatHelpText, Button, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Code } from "@chakra-ui/react";
import { CopyIcon, DownloadIcon, QuestionIcon } from '@chakra-ui/icons'

import { ResultModel } from "../models/ResultModel.tsx";

export default function Result(resultModel: ResultModel) {
    const { onCopy } = useClipboard(resultModel.digest_value.toString())
    const { isOpen, onOpen, onClose } = useDisclosure()
    const toast = useToast()

    const downloadArchive = (result_id: Number) => {
        const downloadUrl = `/api/result/${result_id}`
        fetch(downloadUrl)
            .then(response => {
                const disposition = response.headers.get('Content-Disposition');
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition!);
                const filename = matches && matches[1] ? matches[1].replace(/['"]/g, '') : `result_${result_id}.zip`;
                response.blob().then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                });
            });
    }

    return <Box w="90%" borderWidth="1px">
        <Flex flex={1} direction="row">
            <Flex flex={9} direction="column" p={5} gap={3}>
                <Flex flex={1}>
                    <Center flex="true" flexWrap="wrap" gap={2}>
                        <Heading as='h2' size='lg'>
                            {resultModel.nume + " " + resultModel.prenume}
                        </Heading>
                        <Heading as='h2' size='lg'>
                            {resultModel.grupa}
                        </Heading>
                    </Center>
                    <Spacer />
                    <Center gap={4}>
                        <Heading as="h4" size="s" alignContent="center">
                            <Badge fontSize="1.5em" display="flex" flexWrap="wrap" gap={2}>
                                <Moment date={resultModel.ts} format="YYYY-MM-DD" />
                                <Moment date={resultModel.ts} format="HH:mm:ss" />
                            </Badge>
                        </Heading>
                    </Center>
                </Flex>
                <Flex flex={1} gap={3}>
                    <InputGroup>
                        <InputLeftAddon pointerEvents='none' p={3}>
                            Digest
                        </InputLeftAddon>
                        <Input fontWeight="bold" type="text" pr="4.5rem" value={resultModel.digest_value.toString()} isReadOnly />
                        <InputRightElement width="4.5rem">
                            <Tooltip label="Copiază digest" aria-label='A tooltip'>
                                <IconButton h="1.75rem" aria-label="Copiere digest" onClick={() => {
                                    onCopy();
                                    toast({
                                        position: 'top',
                                        title: 'Digest-ul a fost copiat.',
                                        duration: 1000,
                                        variant: 'left-accent',
                                        isClosable: true,
                                    })
                                }} icon={<CopyIcon />} />
                            </Tooltip>
                        </InputRightElement>
                    </InputGroup>
                    <IconButton aria-label="Descarca arhiva" icon={<DownloadIcon />} onClick={() => downloadArchive(resultModel.id)} colorScheme='teal' />
                </Flex>
            </Flex>
            <Box bg={Number(resultModel.nota) <= 50 ? "red.200" : "green.200"} flex={1} alignContent={"center"} p={2}>
                <Stat>
                    <StatLabel fontSize="1.5em" fontWeight="bold">Notă</StatLabel>
                    <StatNumber>{resultModel.nota === -1 ? 'NaN' : resultModel.nota.toString()}</StatNumber>
                    {resultModel.mesaj_output && <StatHelpText>
                        <Button onClick={onOpen} leftIcon={<QuestionIcon />}>Output</Button>
                    </StatHelpText>}
                </Stat>
            </Box>
            <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Output execuție</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Code style={{ whiteSpace: 'pre-line' }} width="100%">{resultModel.mesaj_output}</Code>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onClose}>
                            Închide
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Flex >
    </Box >
}